var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "340.16px",
    height: "340.16px",
    viewBox: "0 0 340.16 340.16",
    enableBackground: "new 0 0 340.16 340.16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M293.761,168.335c0,67.274-54.532,121.808-121.802,121.808c-67.275,0-121.808-54.533-121.808-121.808 c0-67.273,54.533-121.807,121.808-121.807C239.229,46.528,293.761,101.062,293.761,168.335z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F5F5",
    cx: 171,
    cy: 168.335,
    r: 90.528
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M80.463,206.767v-9.325h12.972l22.431-60.942h-13.649v-9.327h26.216l24.457,70.269h12.837v9.325h-32.838 v-9.325h8.514l-4.324-12.298h-29.186l-4.594,12.298h8.65v9.325H80.463z M111.275,175.824h22.562l-10.674-35.003L111.275,175.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M153.605,127.173h29.865l22.7,57.971l22.432-57.971h28.781v9.327h-12.701v60.942h12.701v9.325h-32.158 v-9.325h8.646V136.5l-6.077,17.565l-16.486,43.104h-11.624l-17.289-43.375l-6.22-17.294l-0.408,60.942h8.92v9.325h-31.619v-9.325 h12.972l0.135-60.942h-12.568V127.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.323,185.578l-17.754-0.72l-0.027-0.278l13.678-8.391l-15.051-5.477l-0.028-0.275l17.267-4.2 l0.167,1.68l-12.355,2.934l13.124,4.819l0.043,0.438l-12.012,7.383l12.786,0.434L73.323,185.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68.368,152.796l0.858-1.312c0.866,0.53,1.553,1.116,2.057,1.756s0.87,1.343,1.094,2.107 c0.227,0.765,0.298,1.614,0.216,2.548c-0.181,2.07-1.014,3.629-2.502,4.675c-1.489,1.047-3.106,1.494-4.854,1.342 c-1.644-0.145-3.067-0.766-4.267-1.867c-1.528-1.395-2.2-3.144-2.017-5.246c0.189-2.164,1.179-3.818,2.967-4.964 c1.265-0.815,2.782-1.153,4.556-1.014l-0.996,11.419c1.509,0.1,2.784-0.263,3.827-1.09c1.042-0.826,1.622-1.909,1.74-3.249 c0.056-0.646-0.004-1.285-0.181-1.917c-0.176-0.631-0.436-1.177-0.778-1.638C69.744,153.885,69.17,153.368,68.368,152.796z  M64.876,152.492c-0.909,0.14-1.647,0.396-2.216,0.766c-0.568,0.371-1.045,0.884-1.431,1.541 c-0.385,0.657-0.611,1.362-0.678,2.118c-0.108,1.245,0.208,2.352,0.947,3.318c0.539,0.707,1.389,1.279,2.553,1.718 L64.876,152.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.238,139.389l0.423-1.608l5.573,1.465l-4.025-7.356l0.509-1.936l4.082,7.3l8.621-4.434l-0.533,2.026 l-7.487,3.737l0.536,1.109l5.311,1.396l-0.422,1.607l-5.31-1.395l-1.007,0.68l4.693,6.895l-0.537,2.045l-5.361-8.021l-7.104,4.25 l0.509-1.937l7.088-4.363L62.238,139.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.819,131.258l-8.575-9.218l0.349-0.78l12.579,0.267l0.625-1.397l2.818,1.26l-0.646,1.442l-1.518-0.679 l-4.303,9.619l1.583,0.708l-0.66,1.475l-2.883-1.289L76.819,131.258z M70.767,122.725l6.701,7.079l2.981-6.663L70.767,122.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.21,113.644l0.914-1.472l10.825,1.558l-6.28-8.893l0.92-1.483l11.105,15.822l-0.911,1.472 l-3.592-5.112L72.21,113.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.538,97.997l-4.72,5.714l4.833,3.992l-1.044,1.263l-10.035-8.287l1.044-1.264l3.984,3.291l4.719-5.715 l-3.984-3.29l1.043-1.264l10.036,8.287l-1.045,1.263L91.538,97.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.297,80.323l8.652,9.723l-1.208,1.074l-1.488-1.671c0.055,1.094-0.094,2.086-0.446,2.976 c-0.353,0.89-0.907,1.672-1.666,2.347c-1.346,1.198-2.94,1.723-4.783,1.573c-1.841-0.149-3.398-0.939-4.67-2.369 c-1.246-1.4-1.83-3.025-1.753-4.876c0.077-1.851,0.792-3.378,2.144-4.582c0.782-0.695,1.64-1.155,2.574-1.378 c0.935-0.223,1.943-0.208,3.026,0.046l-1.589-1.788L100.297,80.323z M96.254,85.634c-0.681,0.606-1.158,1.337-1.43,2.192 s-0.303,1.744-0.093,2.667c0.21,0.922,0.622,1.728,1.237,2.418c0.608,0.684,1.362,1.186,2.262,1.505 c0.9,0.319,1.794,0.395,2.684,0.228c0.889-0.167,1.666-0.547,2.33-1.138c0.669-0.596,1.15-1.334,1.444-2.213 c0.292-0.878,0.338-1.756,0.138-2.633c-0.202-0.876-0.63-1.684-1.286-2.422c-1.002-1.124-2.201-1.742-3.599-1.853 C98.543,84.274,97.314,84.69,96.254,85.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.404,77.229l1.384-0.879l1.282,2.021c0.059-1.115,0.321-2.09,0.789-2.925s1.14-1.53,2.014-2.087 c1.528-0.969,3.191-1.236,4.992-0.802c1.799,0.435,3.203,1.444,4.207,3.026c1.026,1.615,1.358,3.329,0.997,5.14 c-0.36,1.812-1.3,3.199-2.821,4.165c-0.855,0.543-1.758,0.861-2.707,0.953c-0.948,0.092-1.941-0.038-2.977-0.391l3.75,5.909 l-1.384,0.878L104.404,77.229z M110.625,74.794c-1.197,0.76-1.933,1.827-2.209,3.201c-0.276,1.374-0.011,2.695,0.796,3.967 c0.529,0.834,1.188,1.468,1.976,1.902c0.788,0.434,1.645,0.63,2.573,0.588c0.929-0.042,1.771-0.303,2.526-0.783 c0.743-0.471,1.316-1.111,1.722-1.92c0.404-0.809,0.576-1.689,0.514-2.642c-0.06-0.952-0.335-1.815-0.826-2.589 c-0.495-0.78-1.156-1.397-1.985-1.853c-0.828-0.455-1.691-0.67-2.587-0.644C112.227,74.049,111.394,74.307,110.625,74.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.999,65.376c1.8-0.781,3.582-0.763,5.343,0.055c1.603,0.748,2.765,1.952,3.485,3.612 c0.724,1.668,0.788,3.373,0.192,5.113c-0.595,1.741-1.786,2.998-3.572,3.773c-1.793,0.778-3.529,0.791-5.207,0.037 c-1.678-0.754-2.88-1.965-3.603-3.633c-0.718-1.653-0.802-3.32-0.254-5.002C121.986,67.479,123.192,66.161,124.999,65.376z  M125.646,66.882c-1.25,0.543-2.121,1.48-2.608,2.814c-0.489,1.333-0.443,2.669,0.138,4.008c0.374,0.863,0.929,1.58,1.663,2.147 c0.732,0.569,1.536,0.904,2.409,1.008c0.873,0.104,1.726-0.026,2.56-0.388s1.51-0.897,2.032-1.605 c0.521-0.708,0.823-1.524,0.91-2.448c0.085-0.924-0.059-1.818-0.434-2.681c-0.581-1.338-1.527-2.284-2.838-2.836 C128.166,66.349,126.889,66.343,125.646,66.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M138.473,72.854l1.716-12.472l0.825-0.223l7.75,9.912l1.478-0.399l0.805,2.979l-1.525,0.413l-0.435-1.604 l-10.172,2.751l0.453,1.674l-1.56,0.422l-0.825-3.048L138.473,72.854z M141.255,62.769l-1.245,9.668l7.046-1.905L141.255,62.769z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.431,63.469l-7.352,0.936l0.791,6.218l-1.626,0.207l-1.642-12.91l1.625-0.207l0.653,5.126 l7.353-0.936l-0.652-5.126l1.626-0.207l1.642,12.911l-1.625,0.207L160.431,63.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M178.836,56.479l-0.256,13.012l-1.615-0.031l0.044-2.236c-0.704,0.839-1.487,1.466-2.351,1.88 c-0.862,0.414-1.802,0.611-2.816,0.591c-1.802-0.035-3.328-0.733-4.578-2.094s-1.856-2.998-1.818-4.911 c0.037-1.874,0.712-3.464,2.026-4.77c1.313-1.306,2.875-1.942,4.687-1.906c1.045,0.021,1.986,0.267,2.825,0.738 c0.838,0.471,1.567,1.167,2.189,2.089l0.047-2.393L178.836,56.479z M172.261,57.631c-0.912-0.019-1.758,0.194-2.539,0.637 c-0.782,0.443-1.408,1.074-1.88,1.894c-0.472,0.819-0.717,1.691-0.734,2.614c-0.019,0.917,0.193,1.797,0.638,2.642 c0.443,0.845,1.048,1.508,1.814,1.99c0.767,0.481,1.595,0.73,2.483,0.748c0.896,0.017,1.75-0.197,2.563-0.644 c0.812-0.446,1.441-1.059,1.89-1.839s0.682-1.664,0.702-2.651c0.028-1.506-0.432-2.773-1.383-3.804 C174.863,58.188,173.68,57.658,172.261,57.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M187.88,64.967l-1.155-0.172l-4.454,5.226l-1.75-0.261l4.681-5.361c-0.927-0.259-1.639-0.738-2.135-1.437 s-0.677-1.501-0.542-2.409c0.17-1.136,0.639-1.965,1.407-2.487c0.769-0.522,1.701-0.702,2.798-0.538l3.832,0.571l-1.92,12.872 l-1.621-0.241L187.88,64.967z M188.727,59.288l-1.064-0.159c-1.035-0.155-1.74-0.191-2.114-0.11 c-0.375,0.081-0.692,0.27-0.949,0.566c-0.257,0.296-0.428,0.721-0.509,1.272c-0.079,0.528-0.01,0.984,0.21,1.368 c0.219,0.383,0.488,0.64,0.809,0.768c0.32,0.128,0.96,0.264,1.917,0.407l1.064,0.159L188.727,59.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M210.772,58.87l1.608,19.276l-1.751-0.629l-0.591-6.365l-6.982-2.509l-4.482,4.541l-1.807-0.649 l13.607-13.808L210.772,58.87z M209.303,62.315l-4.932,4.996l5.542,1.991L209.303,62.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M229.692,75.89l-1.535,0.104c-0.257-1.875-1.239-3.276-2.944-4.204c-1.362-0.742-2.737-0.911-4.125-0.505 c-1.389,0.405-2.431,1.248-3.129,2.528c-0.453,0.833-0.672,1.729-0.658,2.689c0.015,0.96,0.273,1.839,0.773,2.638 c0.502,0.799,1.201,1.443,2.098,1.932c1.645,0.895,3.35,0.957,5.12,0.186l0.723,1.388c-0.982,0.531-2.048,0.779-3.196,0.742 c-1.149-0.037-2.299-0.37-3.45-0.997c-1.77-0.963-2.923-2.336-3.464-4.119c-0.539-1.783-0.361-3.498,0.535-5.144 c0.603-1.106,1.435-1.986,2.496-2.639c1.063-0.651,2.213-0.985,3.457-0.998c1.242-0.014,2.453,0.301,3.633,0.942 c0.74,0.404,1.392,0.908,1.956,1.515c0.562,0.606,0.982,1.225,1.26,1.858C229.52,74.438,229.67,75.133,229.692,75.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M242.988,85.538l-1.535-0.119c0.016-1.893-0.752-3.421-2.305-4.586c-1.241-0.931-2.577-1.296-4.01-1.096 c-1.432,0.199-2.585,0.883-3.459,2.049c-0.569,0.759-0.917,1.613-1.041,2.565c-0.125,0.952,0.003,1.86,0.384,2.724 c0.38,0.862,0.979,1.601,1.797,2.214c1.496,1.123,3.175,1.431,5.037,0.924l0.515,1.479c-1.049,0.384-2.139,0.474-3.27,0.271 c-1.131-0.203-2.221-0.698-3.27-1.485c-1.61-1.208-2.555-2.734-2.83-4.576c-0.277-1.843,0.146-3.514,1.271-5.013 c0.757-1.008,1.708-1.757,2.853-2.25c1.145-0.491,2.333-0.655,3.564-0.488c1.231,0.166,2.384,0.652,3.458,1.458 c0.674,0.505,1.246,1.099,1.716,1.781c0.469,0.681,0.796,1.354,0.979,2.021C243.026,84.076,243.075,84.785,242.988,85.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M252.435,90.39c1.379,1.397,2.006,3.063,1.88,5.001c-0.117,1.765-0.82,3.283-2.108,4.556 c-1.294,1.277-2.859,1.953-4.697,2.027c-1.839,0.074-3.442-0.582-4.811-1.967c-1.374-1.391-2.013-3.004-1.916-4.842 c0.097-1.838,0.791-3.396,2.085-4.673c1.282-1.267,2.807-1.948,4.572-2.044C249.384,88.342,251.049,88.988,252.435,90.39z  M251.265,91.538c-0.959-0.97-2.148-1.441-3.567-1.415c-1.42,0.026-2.649,0.553-3.688,1.578c-0.67,0.661-1.137,1.437-1.401,2.326 c-0.265,0.889-0.288,1.759-0.068,2.611c0.218,0.852,0.647,1.601,1.286,2.247c0.639,0.646,1.382,1.084,2.231,1.314 c0.849,0.229,1.72,0.217,2.612-0.037c0.891-0.254,1.673-0.711,2.343-1.373c1.037-1.026,1.577-2.25,1.618-3.672 S252.217,92.502,251.265,91.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256.166,116.009l-7.016-9.621l10.515-7.668l0.966,1.324l-9.24,6.738l4.367,5.988l9.24-6.738l0.966,1.324 l-9.24,6.738l1.628,2.232l-2.938,2.143l-0.911-1.249L256.166,116.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M270.08,114.063l-8.518,4.492l12.883,3.783l0.061,0.114l-11.514,6.071l-0.764-1.45l8.438-4.45 l-12.77-3.762l-0.092-0.176l11.512-6.072L270.08,114.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M280.748,138.995l-12.287,4.294l-0.533-1.525l2.112-0.738c-1.032-0.366-1.894-0.883-2.582-1.547 c-0.688-0.665-1.199-1.476-1.534-2.434c-0.595-1.702-0.473-3.375,0.367-5.021c0.84-1.645,2.164-2.784,3.97-3.416 c1.771-0.618,3.495-0.539,5.178,0.237s2.822,2.02,3.419,3.729c0.345,0.987,0.442,1.956,0.293,2.906 c-0.149,0.949-0.548,1.876-1.194,2.78l2.259-0.789L280.748,138.995z M277.378,133.234c-0.301-0.862-0.795-1.581-1.481-2.158 c-0.688-0.578-1.498-0.945-2.431-1.102s-1.835-0.083-2.706,0.221c-0.865,0.303-1.616,0.809-2.254,1.519 c-0.639,0.709-1.049,1.508-1.233,2.394c-0.184,0.886-0.13,1.748,0.163,2.587c0.297,0.847,0.795,1.573,1.496,2.178 s1.495,0.982,2.383,1.131c0.887,0.147,1.797,0.06,2.729-0.267c1.421-0.497,2.449-1.37,3.083-2.621 C277.763,135.867,277.847,134.573,277.378,133.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M271.373,157.965l-2.151-11.711l12.8-2.352l0.297,1.612l-11.247,2.066l1.339,7.29l11.247-2.066 l0.296,1.613l-11.247,2.065l0.499,2.718l-3.576,0.656l-0.279-1.52L271.373,157.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M284.746,162.278l-9.625,0.317l9.935,9.032l0.003,0.129l-13.007,0.429l-0.056-1.639l9.535-0.314 l-9.841-8.965l-0.006-0.199l13.007-0.429L284.746,162.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M277.132,181.194l0.108-1.163l-5.464-4.159l0.164-1.762l5.612,4.376c0.207-0.938,0.646-1.675,1.316-2.209 s1.463-0.758,2.375-0.674c1.145,0.107,1.997,0.529,2.562,1.268c0.563,0.738,0.795,1.66,0.692,2.764l-0.36,3.858l-12.958-1.208 l0.151-1.632L277.132,181.194z M282.849,181.728l0.101-1.073c0.096-1.041,0.095-1.747-0.008-2.117 c-0.102-0.37-0.308-0.675-0.617-0.916c-0.31-0.24-0.742-0.386-1.299-0.438c-0.532-0.049-0.982,0.046-1.354,0.286 c-0.371,0.239-0.611,0.522-0.722,0.85c-0.111,0.326-0.211,0.972-0.301,1.936l-0.1,1.072L282.849,181.728z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.314,224.884l14.019-7.108l0.141,0.199l-6.996,12.319l13.955-2.304l0.14,0.197l-11.554,10.669 l-0.84-1.215l8.292-7.572l-12.187,1.968l-0.218-0.315l6.137-10.824l-10.059,5.18L72.314,224.884z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.495,235.958l-6.491,15.802l-1.118-1.183l2.094-5.246l-4.456-4.716l-5.341,1.809l-1.154-1.226 l16.209-5.514L100.495,235.958z M97.961,238.084l-5.874,1.996l3.541,3.741L97.961,238.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.598,242.008l2.32,1.909c1.333,1.088,2.181,1.884,2.55,2.385c0.528,0.715,0.787,1.511,0.775,2.384 c-0.007,0.871-0.34,1.711-0.992,2.505c-0.656,0.803-1.406,1.288-2.243,1.476c-0.84,0.189-1.697,0.07-2.566-0.342 c-0.636-0.3-1.679-1.044-3.129-2.23l-0.83-0.686l-4.587,5.6l-1.167-0.953L106.598,242.008z M106.793,244.144l-3.344,4.089 l1.954,1.638c0.797,0.655,1.439,1.057,1.936,1.215c0.491,0.146,0.979,0.144,1.463-0.019c0.49-0.155,0.902-0.449,1.243-0.86 c0.325-0.408,0.525-0.864,0.585-1.367c0.065-0.507-0.019-0.973-0.249-1.396c-0.229-0.431-0.737-0.97-1.528-1.613L106.793,244.144 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M115.756,249.292l1.294,0.837l-3.151,4.913l8.226-1.672l1.705,1.096l-9.863,1.981l1.943,11.43 l-1.689-1.073l-1.657-9.672l-3.907,6.105l-1.293-0.827L115.756,249.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M125.756,255.446l7.754,3.81l-0.674,1.369l-6.4-3.141l-2.147,4.376l6.344,3.112l-0.671,1.369l-6.348-3.11 l-2.692,5.489l6.348,3.12l-0.67,1.37l-7.7-3.778L125.756,255.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.483,260.857l0.536-1.421l7.726,2.923l-0.536,1.423l-3.142-1.186l-4.968,13.135l-1.436-0.546 l4.962-13.134L133.483,260.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150.132,264.277c2.215,0.535,3.885,1.758,5.005,3.656c1.121,1.885,1.407,3.956,0.861,6.19 c-0.541,2.212-1.743,3.905-3.612,5.084c-1.869,1.178-3.871,1.51-6.016,0.982c-2.175-0.53-3.819-1.745-4.938-3.649 c-1.118-1.895-1.412-3.938-0.879-6.119c0.356-1.456,1.026-2.71,2.01-3.789c0.984-1.078,2.152-1.815,3.496-2.235 C147.408,263.978,148.762,263.938,150.132,264.277z M149.837,265.767c-1.085-0.273-2.182-0.232-3.296,0.12 c-1.111,0.346-2.06,0.949-2.846,1.797c-0.788,0.858-1.33,1.895-1.625,3.107c-0.442,1.797-0.209,3.463,0.697,4.996 c0.905,1.532,2.208,2.51,3.905,2.917c1.138,0.284,2.26,0.25,3.366-0.082c1.106-0.328,2.054-0.924,2.833-1.784 c0.783-0.85,1.321-1.881,1.616-3.086c0.293-1.209,0.292-2.353-0.015-3.456c-0.307-1.103-0.878-2.076-1.717-2.895 C151.911,266.582,150.938,266.033,149.837,265.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M170.572,283.542l-1.631-0.176l-3.697-12.49l-6.317,11.427l-1.628-0.17l8.162-14.792l0.33,0.037 L170.572,283.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180.969,267.556c2.276-0.091,4.221,0.61,5.825,2.116c1.604,1.508,2.456,3.408,2.558,5.707 c0.089,2.271-0.591,4.242-2.052,5.897c-1.473,1.646-3.304,2.522-5.508,2.62c-2.234,0.087-4.153-0.62-5.757-2.134 c-1.604-1.514-2.455-3.384-2.55-5.625c-0.065-1.499,0.226-2.894,0.867-4.206c0.646-1.301,1.558-2.342,2.738-3.124 C178.267,268.037,179.555,267.616,180.969,267.556z M181.099,269.07c-1.114,0.049-2.164,0.392-3.13,1.033 c-0.976,0.644-1.721,1.489-2.236,2.522c-0.517,1.04-0.746,2.187-0.69,3.438c0.075,1.843,0.766,3.377,2.059,4.602 c1.298,1.225,2.815,1.792,4.572,1.714c1.165-0.052,2.23-0.387,3.204-1.021c0.973-0.619,1.714-1.456,2.227-2.499 c0.511-1.043,0.741-2.175,0.692-3.418c-0.056-1.234-0.39-2.34-0.989-3.314c-0.591-0.973-1.411-1.739-2.45-2.298 C183.317,269.269,182.235,269.02,181.099,269.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M195.618,281.927l-1.468,0.308l-3.145-15.25l7.396-1.527l0.311,1.5l-5.915,1.219L195.618,281.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M206.158,262.383c2.13-0.834,4.191-0.789,6.192,0.114c2.014,0.903,3.425,2.431,4.26,4.574 c0.838,2.12,0.818,4.207-0.026,6.239c-0.855,2.032-2.316,3.455-4.369,4.264c-2.082,0.809-4.131,0.759-6.135-0.154 c-2.004-0.918-3.418-2.423-4.229-4.514c-0.551-1.39-0.729-2.807-0.539-4.25c0.188-1.444,0.717-2.727,1.583-3.837 C203.759,263.7,204.847,262.888,206.158,262.383z M206.771,263.763c-1.044,0.41-1.92,1.07-2.629,1.994 c-0.71,0.922-1.144,1.961-1.295,3.104c-0.161,1.155-0.01,2.317,0.451,3.478c0.669,1.72,1.813,2.955,3.439,3.691 c1.611,0.737,3.243,0.785,4.874,0.147c1.09-0.419,1.994-1.094,2.704-2.002c0.712-0.906,1.146-1.938,1.304-3.078 c0.146-1.153-0.005-2.313-0.453-3.467c-0.458-1.153-1.121-2.091-1.999-2.816c-0.891-0.727-1.909-1.191-3.067-1.384 C208.936,263.239,207.824,263.348,206.771,263.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M215.441,258.609l2.53-1.555c1.021-0.629,1.88-0.984,2.583-1.064c0.702-0.092,1.372,0.028,2.002,0.352 c0.631,0.323,1.147,0.806,1.538,1.435c0.36,0.583,0.546,1.212,0.564,1.865c0.02,0.654-0.145,1.294-0.503,1.932 c0.814-0.179,1.499-0.221,2.052-0.125c0.553,0.095,1.063,0.306,1.539,0.631c0.478,0.328,0.868,0.749,1.198,1.271 c0.649,1.073,0.827,2.196,0.524,3.404c-0.305,1.195-1.093,2.18-2.357,2.966l-3.532,2.156L215.441,258.609z M217.494,259.138 l2.607,4.253l0.733-0.462c0.895-0.541,1.505-1.033,1.818-1.46c0.315-0.426,0.478-0.902,0.501-1.42 c0.009-0.527-0.12-1.006-0.391-1.46c-0.374-0.613-0.876-0.955-1.494-1.049c-0.631-0.094-1.392,0.133-2.28,0.68L217.494,259.138z  M220.922,264.717l3.124,5.097l1.592-0.98c0.934-0.577,1.57-1.098,1.891-1.555c0.319-0.456,0.49-0.965,0.508-1.532 c0.015-0.565-0.12-1.08-0.401-1.554c-0.361-0.584-0.868-0.991-1.509-1.203c-0.639-0.211-1.34-0.191-2.089,0.053 c-0.511,0.152-1.306,0.57-2.393,1.231L220.922,264.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M241.342,241.795l-0.213,1.507c-1.08-0.187-2.114-0.125-3.093,0.174c-0.977,0.31-1.865,0.836-2.654,1.603 c-0.872,0.818-1.48,1.811-1.802,2.95c-0.333,1.129-0.363,2.257-0.074,3.375s0.863,2.136,1.735,3.036 c1.304,1.384,2.855,2.093,4.64,2.144c1.787,0.05,3.382-0.592,4.77-1.91c1.53-1.462,2.215-3.291,2.069-5.507l1.497-0.154 c0.147,1.232-0.011,2.442-0.444,3.601c-0.444,1.169-1.163,2.233-2.171,3.183c-1.905,1.827-4.04,2.6-6.396,2.338 c-1.978-0.223-3.721-1.127-5.214-2.69c-1.568-1.652-2.334-3.569-2.288-5.77c0.048-2.19,0.915-4.089,2.601-5.694 c1.016-0.978,2.132-1.642,3.35-2.006C238.873,241.606,240.101,241.548,241.342,241.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M241.784,236.664l1.092-1.037l4.498,4.731l5.559-5.284l-4.499-4.73l1.093-1.039l10.726,11.292 l-1.093,1.037l-5.176-5.453l-5.569,5.285l5.188,5.453l-1.093,1.037L241.784,236.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M265.746,232.477l-0.892,1.204l-12.512-9.272l4.499-6.068l1.222,0.915l-3.598,4.85L265.746,232.477z"
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 171.95,
    y1: 8.284,
    x2: 171.95,
    y2: 19.011
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 166.312,
    y1: 8.382,
    x2: 166.684,
    y2: 19.104
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 160.68,
    y1: 8.678,
    x2: 161.432,
    y2: 19.378
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 155.063,
    y1: 9.167,
    x2: 156.186,
    y2: 19.84
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 149.47,
    y1: 9.858,
    x2: 150.961,
    y2: 20.477
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 143.903,
    y1: 10.737,
    x2: 145.76,
    y2: 21.298
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 138.365,
    y1: 11.815,
    x2: 140.595,
    y2: 22.303
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 132.873,
    y1: 13.081,
    x2: 135.467,
    y2: 23.488
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 127.428,
    y1: 14.543,
    x2: 130.383,
    y2: 24.853
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 122.033,
    y1: 16.188,
    x2: 125.348,
    y2: 26.391
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 116.702,
    y1: 18.022,
    x2: 120.37,
    y2: 28.101
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 111.441,
    y1: 20.046,
    x2: 115.459,
    y2: 29.987
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 106.249,
    y1: 22.246,
    x2: 110.613,
    y2: 32.045
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 101.14,
    y1: 24.632,
    x2: 105.84,
    y2: 34.269
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 96.115,
    y1: 27.192,
    x2: 101.153,
    y2: 36.658
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 91.186,
    y1: 29.921,
    x2: 96.544,
    y2: 39.213
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 86.352,
    y1: 32.823,
    x2: 92.033,
    y2: 41.923
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 81.621,
    y1: 35.897,
    x2: 87.621,
    y2: 44.786
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 77.001,
    y1: 39.13,
    x2: 83.307,
    y2: 47.807
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 72.5,
    y1: 42.522,
    x2: 79.106,
    y2: 50.974
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 68.119,
    y1: 46.069,
    x2: 75.011,
    y2: 54.289
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 63.864,
    y1: 49.771,
    x2: 71.043,
    y2: 57.743
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 59.742,
    y1: 53.618,
    x2: 67.192,
    y2: 61.329
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 55.753,
    y1: 57.601,
    x2: 63.472,
    y2: 65.051
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 51.906,
    y1: 61.725,
    x2: 59.876,
    y2: 68.901
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 48.21,
    y1: 65.981,
    x2: 56.423,
    y2: 72.874
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 44.66,
    y1: 70.362,
    x2: 53.113,
    y2: 76.966
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 41.265,
    y1: 74.863,
    x2: 49.946,
    y2: 81.169
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 38.036,
    y1: 79.481,
    x2: 46.927,
    y2: 85.479
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 34.964,
    y1: 84.209,
    x2: 44.057,
    y2: 89.895
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 32.059,
    y1: 89.042,
    x2: 41.348,
    y2: 94.405
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 29.326,
    y1: 93.975,
    x2: 38.797,
    y2: 99.009
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 26.764,
    y1: 99,
    x2: 36.408,
    y2: 103.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 24.382,
    y1: 104.111,
    x2: 34.181,
    y2: 108.467
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 22.175,
    y1: 109.298,
    x2: 32.125,
    y2: 113.314
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 20.16,
    y1: 114.563,
    x2: 30.238,
    y2: 118.23
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 18.325,
    y1: 119.891,
    x2: 28.519,
    y2: 123.208
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 16.672,
    y1: 125.284,
    x2: 26.981,
    y2: 128.239
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 15.214,
    y1: 130.729,
    x2: 25.623,
    y2: 133.326
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 13.944,
    y1: 136.223,
    x2: 24.438,
    y2: 138.453
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 12.872,
    y1: 141.757,
    x2: 23.432,
    y2: 143.621
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 11.985,
    y1: 147.325,
    x2: 22.609,
    y2: 148.818
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 11.3,
    y1: 152.926,
    x2: 21.965,
    y2: 154.046
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 10.81,
    y1: 158.541,
    x2: 21.504,
    y2: 159.285
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 10.513,
    y1: 164.172,
    x2: 21.23,
    y2: 164.543
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 10.416,
    y1: 169.812,
    x2: 21.14,
    y2: 169.812
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 10.512,
    y1: 175.443,
    x2: 21.229,
    y2: 175.064
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 10.809,
    y1: 181.076,
    x2: 21.504,
    y2: 180.324
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 11.299,
    y1: 186.691,
    x2: 21.964,
    y2: 185.565
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 11.985,
    y1: 192.29,
    x2: 22.609,
    y2: 190.792
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 12.869,
    y1: 197.859,
    x2: 23.43,
    y2: 195.994
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 13.94,
    y1: 203.39,
    x2: 24.434,
    y2: 201.159
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 15.213,
    y1: 208.889,
    x2: 25.62,
    y2: 206.289
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 16.667,
    y1: 214.333,
    x2: 26.978,
    y2: 211.37
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 18.32,
    y1: 219.717,
    x2: 28.517,
    y2: 216.405
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 20.155,
    y1: 225.051,
    x2: 30.233,
    y2: 221.379
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 22.172,
    y1: 230.313,
    x2: 32.118,
    y2: 226.297
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 24.377,
    y1: 235.512,
    x2: 34.175,
    y2: 231.146
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 26.758,
    y1: 240.621,
    x2: 36.4,
    y2: 235.916
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 29.317,
    y1: 245.645,
    x2: 38.789,
    y2: 240.608
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 32.051,
    y1: 250.568,
    x2: 41.34,
    y2: 245.205
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 34.956,
    y1: 255.407,
    x2: 44.048,
    y2: 249.722
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 38.027,
    y1: 260.131,
    x2: 46.918,
    y2: 254.135
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 41.261,
    y1: 264.754,
    x2: 49.938,
    y2: 258.45
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 44.654,
    y1: 269.248,
    x2: 53.104,
    y2: 262.652
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 48.201,
    y1: 273.636,
    x2: 56.414,
    y2: 266.741
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 51.896,
    y1: 277.894,
    x2: 59.87,
    y2: 270.712
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 55.741,
    y1: 282.019,
    x2: 63.46,
    y2: 274.568
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 59.731,
    y1: 286.001,
    x2: 67.182,
    y2: 278.285
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 63.855,
    y1: 289.846,
    x2: 71.031,
    y2: 281.878
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 68.107,
    y1: 293.543,
    x2: 75,
    y2: 285.332
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 72.492,
    y1: 297.091,
    x2: 79.095,
    y2: 288.641
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 76.995,
    y1: 300.49,
    x2: 83.293,
    y2: 291.813
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 81.613,
    y1: 303.725,
    x2: 87.608,
    y2: 294.834
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 86.341,
    y1: 306.791,
    x2: 92.025,
    y2: 297.697
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 91.172,
    y1: 309.696,
    x2: 96.538,
    y2: 300.413
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 96.101,
    y1: 312.436,
    x2: 101.139,
    y2: 302.966
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 101.126,
    y1: 314.998,
    x2: 105.833,
    y2: 305.349
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 106.234,
    y1: 317.371,
    x2: 110.599,
    y2: 307.572
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 111.425,
    y1: 319.573,
    x2: 115.443,
    y2: 309.637
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 116.689,
    y1: 321.595,
    x2: 120.361,
    y2: 311.522
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 122.021,
    y1: 323.438,
    x2: 125.334,
    y2: 313.229
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 127.413,
    y1: 325.083,
    x2: 130.37,
    y2: 314.778
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 132.857,
    y1: 326.544,
    x2: 135.452,
    y2: 316.133
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 138.35,
    y1: 327.807,
    x2: 140.581,
    y2: 317.322
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 143.886,
    y1: 328.889,
    x2: 145.747,
    y2: 318.327
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 149.455,
    y1: 329.771,
    x2: 150.946,
    y2: 319.146
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 155.049,
    y1: 330.461,
    x2: 156.171,
    y2: 319.789
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 160.666,
    y1: 330.944,
    x2: 161.417,
    y2: 320.243
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 166.296,
    y1: 331.247,
    x2: 166.676,
    y2: 320.525
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 171.936,
    y1: 331.345,
    x2: 171.936,
    y2: 320.615
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 177.574,
    y1: 331.249,
    x2: 177.196,
    y2: 320.525
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 183.2,
    y1: 330.945,
    x2: 182.455,
    y2: 320.245
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 188.821,
    y1: 330.461,
    x2: 187.699,
    y2: 319.789
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 194.42,
    y1: 329.771,
    x2: 192.923,
    y2: 319.146
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 199.989,
    y1: 328.891,
    x2: 198.118,
    y2: 318.332
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 205.521,
    y1: 327.809,
    x2: 203.291,
    y2: 317.327
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 211.012,
    y1: 326.549,
    x2: 208.421,
    y2: 316.137
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 216.463,
    y1: 325.088,
    x2: 213.502,
    y2: 314.781
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 221.849,
    y1: 323.441,
    x2: 218.536,
    y2: 313.233
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 227.18,
    y1: 321.599,
    x2: 223.512,
    y2: 311.526
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 232.446,
    y1: 319.578,
    x2: 228.427,
    y2: 309.642
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 237.631,
    y1: 317.378,
    x2: 233.277,
    y2: 307.579
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 242.741,
    y1: 315.004,
    x2: 238.045,
    y2: 305.355
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 247.766,
    y1: 312.441,
    x2: 242.739,
    y2: 302.973
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 252.698,
    y1: 309.703,
    x2: 247.334,
    y2: 300.418
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 257.539,
    y1: 306.798,
    x2: 251.854,
    y2: 297.707
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 262.262,
    y1: 303.732,
    x2: 256.264,
    y2: 294.845
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 266.884,
    y1: 300.5,
    x2: 260.573,
    y2: 291.823
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 271.381,
    y1: 297.101,
    x2: 264.781,
    y2: 288.651
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 275.769,
    y1: 293.553,
    x2: 268.874,
    y2: 285.341
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 280.024,
    y1: 289.853,
    x2: 272.844,
    y2: 281.887
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 284.15,
    y1: 286.014,
    x2: 276.697,
    y2: 278.294
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 288.133,
    y1: 282.029,
    x2: 280.414,
    y2: 274.579
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 291.973,
    y1: 277.905,
    x2: 284.01,
    y2: 270.725
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 295.676,
    y1: 273.647,
    x2: 287.46,
    y2: 266.754
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 299.222,
    y1: 269.263,
    x2: 290.771,
    y2: 262.667
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 302.62,
    y1: 264.765,
    x2: 293.944,
    y2: 258.455
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 305.855,
    y1: 260.141,
    x2: 296.959,
    y2: 254.146
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 308.923,
    y1: 255.42,
    x2: 299.83,
    y2: 249.736
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 311.827,
    y1: 250.582,
    x2: 302.532,
    y2: 245.217
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 314.555,
    y1: 245.647,
    x2: 305.084,
    y2: 240.621
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 317.114,
    y1: 240.635,
    x2: 307.479,
    y2: 235.931
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 319.503,
    y1: 235.516,
    x2: 309.705,
    y2: 231.162
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 321.703,
    y1: 230.33,
    x2: 311.762,
    y2: 226.311
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 323.727,
    y1: 225.062,
    x2: 313.653,
    y2: 221.394
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 325.566,
    y1: 219.734,
    x2: 315.36,
    y2: 216.422
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 327.215,
    y1: 214.347,
    x2: 316.896,
    y2: 211.384
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 328.675,
    y1: 208.902,
    x2: 318.263,
    y2: 206.305
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 329.937,
    y1: 203.404,
    x2: 319.447,
    y2: 201.174
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 331.02,
    y1: 197.873,
    x2: 320.449,
    y2: 196.003
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 331.902,
    y1: 192.306,
    x2: 321.275,
    y2: 190.808
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 332.584,
    y1: 186.705,
    x2: 321.916,
    y2: 185.584
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 333.075,
    y1: 181.084,
    x2: 322.376,
    y2: 180.339
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 333.366,
    y1: 175.458,
    x2: 322.655,
    y2: 175.079
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 333.475,
    y1: 169.825,
    x2: 322.746,
    y2: 169.825
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 333.366,
    y1: 164.182,
    x2: 322.655,
    y2: 164.56
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 333.075,
    y1: 158.554,
    x2: 322.378,
    y2: 159.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 332.584,
    y1: 152.938,
    x2: 321.916,
    y2: 154.056
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 331.904,
    y1: 147.341,
    x2: 321.277,
    y2: 148.832
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 331.023,
    y1: 141.771,
    x2: 320.451,
    y2: 143.636
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 329.94,
    y1: 136.238,
    x2: 319.447,
    y2: 138.465
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 328.679,
    y1: 130.741,
    x2: 318.267,
    y2: 133.338
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 327.218,
    y1: 125.297,
    x2: 316.902,
    y2: 128.254
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 325.566,
    y1: 119.905,
    x2: 315.366,
    y2: 123.217
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 323.73,
    y1: 114.575,
    x2: 313.658,
    y2: 118.244
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 321.709,
    y1: 109.308,
    x2: 311.762,
    y2: 113.329
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 319.509,
    y1: 104.121,
    x2: 309.711,
    y2: 108.479
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 317.122,
    y1: 99.009,
    x2: 307.487,
    y2: 103.715
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 314.563,
    y1: 93.989,
    x2: 305.091,
    y2: 99.02
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 311.835,
    y1: 89.057,
    x2: 302.541,
    y2: 94.419
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 308.931,
    y1: 84.222,
    x2: 299.838,
    y2: 89.908
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 305.863,
    y1: 79.495,
    x2: 296.961,
    y2: 85.491
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 302.63,
    y1: 74.877,
    x2: 293.949,
    y2: 81.181
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 299.231,
    y1: 70.373,
    x2: 290.782,
    y2: 76.979
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 295.686,
    y1: 65.991,
    x2: 287.472,
    y2: 72.887
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 291.984,
    y1: 61.736,
    x2: 284.02,
    y2: 68.913
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 288.145,
    y1: 57.613,
    x2: 280.426,
    y2: 65.062
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 284.152,
    y1: 53.626,
    x2: 276.699,
    y2: 61.34
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 280.035,
    y1: 49.781,
    x2: 272.855,
    y2: 57.752
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 275.78,
    y1: 46.078,
    x2: 268.886,
    y2: 54.301
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 271.393,
    y1: 42.532,
    x2: 264.785,
    y2: 50.983
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 266.896,
    y1: 39.14,
    x2: 260.585,
    y2: 47.818
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 262.273,
    y1: 35.904,
    x2: 256.274,
    y2: 44.796
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 257.547,
    y1: 32.833,
    x2: 251.866,
    y2: 41.93
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 252.714,
    y1: 29.928,
    x2: 247.348,
    y2: 39.217
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 247.779,
    y1: 27.194,
    x2: 242.741,
    y2: 36.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 242.754,
    y1: 24.633,
    x2: 238.061,
    y2: 34.274
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 237.645,
    y1: 22.251,
    x2: 233.28,
    y2: 32.05
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 232.459,
    y1: 20.052,
    x2: 228.44,
    y2: 29.994
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 227.193,
    y1: 18.029,
    x2: 223.524,
    y2: 28.107
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 221.864,
    y1: 16.193,
    x2: 218.552,
    y2: 26.396
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 216.467,
    y1: 14.547,
    x2: 213.515,
    y2: 24.855
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 211.021,
    y1: 13.086,
    x2: 208.436,
    y2: 23.494
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 205.536,
    y1: 11.817,
    x2: 203.307,
    y2: 22.306
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 199.992,
    y1: 10.74,
    x2: 198.131,
    y2: 21.301
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 194.424,
    y1: 9.858,
    x2: 192.938,
    y2: 20.479
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 188.836,
    y1: 9.17,
    x2: 187.713,
    y2: 19.84
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 183.214,
    y1: 8.68,
    x2: 182.47,
    y2: 19.378
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    x1: 177.59,
    y1: 8.382,
    x2: 177.212,
    y2: 19.105
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "171.949,29.198 169.617,33.285 171.949,37.375 174.277,33.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "171.949,302.256 169.617,306.339 171.949,310.434 174.277,306.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "307.725,165.937 305.397,170.03 307.725,174.113 310.054,170.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "35.758,165.937 33.43,170.03 35.758,174.113 38.091,170.03  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M205.798,37.422 c47.211,13.541,84.497,50.655,98.246,97.836c0,0,2.33,7.977,3.532,18.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M222.538,35.744c0,0-1.305,6.261,4.171,9.304C226.709,45.047,228.14,39.042,222.538,35.744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M216.785,48.109c0,0,6.048,2.076,9.749-2.981C226.534,45.128,220.752,42.967,216.785,48.109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M209.22,31.2c0,0-0.574,6.372,5.224,8.752C214.443,39.953,215.152,33.819,209.22,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M204.935,44.149c0,0,6.259,1.359,9.342-4.096C214.276,40.054,208.283,38.582,204.935,44.149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M234.862,41.415c0,0-1.962,6.095,3.166,9.696C238.028,51.111,240.074,45.286,234.862,41.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M227.825,53.102c0,0,5.8,2.708,10.017-1.925C237.842,51.177,232.322,48.408,227.825,53.102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M246.542,48.406c0,0-2.206,6.01,2.77,9.816C249.312,58.223,251.603,52.49,246.542,48.406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M239.051,59.806c0,0,5.685,2.941,10.077-1.525C249.128,58.28,243.729,55.299,239.051,59.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M258.45,56.863c0,0-2.855,5.732,1.665,10.063C260.115,66.926,263.026,61.481,258.45,56.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M249.745,67.36c0,0,5.325,3.552,10.183-0.397C259.928,66.963,254.888,63.399,249.745,67.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M269.412,65.958c0,0-3.453,5.39,0.592,10.178C270.004,76.136,273.465,71.029,269.412,65.958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M259.635,75.467c0,0,4.922,4.102,10.166,0.688C269.801,76.155,265.173,72.075,259.635,75.467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M279.159,76.442c0,0-3.664,5.247,0.188,10.194C279.347,86.636,283.018,81.673,279.159,76.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M269.012,85.55c0,0,4.749,4.293,10.135,1.094C279.146,86.644,274.688,82.384,269.012,85.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M288.749,88.239c0,0-4.36,4.689-1.24,10.12C287.509,98.358,291.838,93.952,288.749,88.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M277.436,95.848c0,0,4.102,4.912,9.882,2.491C287.317,98.339,283.484,93.498,277.436,95.848"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M297.036,101.131c0,0-4.836,4.201-2.304,9.936C294.732,111.066,299.501,107.141,297.036,101.131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M284.969,107.501c0,0,3.564,5.314,9.566,3.523C294.535,111.024,291.246,105.805,284.969,107.501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M303.364,114.396c0,0-4.994,4-2.707,9.831C300.657,124.227,305.582,120.499,303.364,114.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M291.055,120.271c0,0,3.34,5.457,9.417,3.91C300.472,124.181,297.393,118.832,291.055,120.271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M308.537,128.58c0,0-5.329,3.545-3.557,9.555C304.98,138.135,310.208,134.857,308.537,128.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M295.759,133.35c0,0,2.861,5.729,9.039,4.725C304.798,138.075,302.194,132.475,295.759,133.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M197.006,35.209c0,0,4.135,4.892,9.9,2.439C206.906,37.649,203.051,32.828,197.006,35.209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M138.092,37.422 c-47.209,13.541-84.496,50.655-98.242,97.836c0,0-2.326,7.977-3.536,18.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M121.359,35.744c0,0,1.305,6.261-4.172,9.304C117.187,45.047,115.76,39.042,121.359,35.744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M127.111,48.109c0,0-6.054,2.076-9.751-2.981C117.36,45.128,123.146,42.967,127.111,48.109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M134.678,31.2c0,0,0.573,6.372-5.224,8.752C129.454,39.953,128.739,33.819,134.678,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M138.956,44.149c0,0-6.25,1.359-9.338-4.096C129.617,40.054,135.615,38.582,138.956,44.149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M109.029,41.415c0,0,1.968,6.095-3.16,9.696C105.869,51.111,103.817,45.286,109.029,41.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M116.066,53.102c0,0-5.8,2.708-10.014-1.925C106.052,51.177,111.57,48.408,116.066,53.102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M97.348,48.406c0,0,2.208,6.01-2.768,9.816C94.58,58.223,92.294,52.49,97.348,48.406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M104.847,59.806c0,0-5.687,2.941-10.084-1.525C94.763,58.28,100.168,55.299,104.847,59.806"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M85.44,56.863c0,0,2.86,5.732-1.665,10.063C83.775,66.926,80.867,61.481,85.44,56.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M94.151,67.36c0,0-5.322,3.552-10.189-0.397C83.962,66.963,89.007,63.399,94.151,67.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M74.487,65.958c0,0,3.45,5.39-0.595,10.178C73.893,76.136,70.429,71.029,74.487,65.958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M84.262,75.467c0,0-4.92,4.102-10.171,0.688C74.09,76.155,78.725,72.075,84.262,75.467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M64.732,76.442c0,0,3.664,5.247-0.18,10.194C64.552,86.636,60.881,81.673,64.732,76.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M74.885,85.55c0,0-4.749,4.293-10.136,1.094C64.749,86.644,69.21,82.384,74.885,85.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M55.142,88.239c0,0,4.359,4.689,1.243,10.12C56.385,98.358,52.059,93.952,55.142,88.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M66.464,95.848c0,0-4.106,4.912-9.89,2.491C56.574,98.339,60.408,93.498,66.464,95.848"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M46.86,101.131c0,0,4.831,4.201,2.307,9.936C49.167,111.066,44.396,107.141,46.86,101.131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M58.921,107.501c0,0-3.562,5.314-9.566,3.523C49.355,111.024,52.652,105.805,58.921,107.501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M40.534,114.396c0,0,4.996,4,2.7,9.831C43.233,124.227,38.314,120.499,40.534,114.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M52.842,120.271c0,0-3.345,5.457-9.416,3.91C43.427,124.181,46.504,118.832,52.842,120.271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M35.355,128.58c0,0,5.33,3.545,3.558,9.555C38.914,138.135,33.682,134.857,35.355,128.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M48.132,133.35c0,0-2.854,5.729-9.039,4.725C39.094,138.075,41.698,132.475,48.132,133.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M146.886,35.209c0,0-4.138,4.892-9.9,2.439C136.986,37.649,140.848,32.828,146.886,35.209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M205.798,300.956 c47.211-13.552,84.497-50.656,98.246-97.837c0,0,2.33-7.982,3.532-18.411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M222.538,302.635c0,0-1.305-6.271,4.171-9.309C226.709,293.326,228.14,299.331,222.538,302.635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M216.785,290.269c0,0,6.048-2.088,9.749,2.974C226.534,293.242,220.752,295.41,216.785,290.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M209.22,307.177c0,0-0.574-6.376,5.224-8.763C214.443,298.414,215.152,304.547,209.22,307.177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M204.935,294.223c0,0,6.259-1.364,9.342,4.09C214.276,298.313,208.283,299.791,204.935,294.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M234.862,296.963c0,0-1.962-6.101,3.166-9.696C238.028,287.267,240.074,293.081,234.862,296.963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M227.825,285.275c0,0,5.8-2.715,10.017,1.921C237.842,287.196,232.322,289.958,227.825,285.275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M246.542,289.958c0,0-2.206-6.008,2.77-9.804C249.312,280.154,251.603,285.883,246.542,289.958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M239.051,278.572c0,0,5.685-2.945,10.077,1.518C249.128,280.09,243.729,283.073,239.051,278.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M258.45,281.504c0,0-2.855-5.722,1.665-10.053C260.115,271.451,263.026,276.896,258.45,281.504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M249.745,271.017c0,0,5.325-3.552,10.183,0.394C259.928,271.41,254.888,274.973,249.745,271.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M269.412,272.414c0,0-3.453-5.395,0.592-10.179C270.004,262.235,273.465,267.349,269.412,272.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M259.635,262.903c0,0,4.922-4.1,10.166-0.681C269.801,262.223,265.173,266.297,259.635,262.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M279.159,261.93c0,0-3.664-5.249,0.188-10.189C279.347,251.74,283.018,256.699,279.159,261.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M269.012,252.822c0,0,4.749-4.286,10.135-1.094C279.146,251.729,274.688,255.994,269.012,252.822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M288.749,250.133c0,0-4.36-4.688-1.24-10.118C287.509,240.015,291.838,244.422,288.749,250.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M277.436,242.529c0,0,4.102-4.91,9.882-2.496C287.317,240.033,283.484,244.868,277.436,242.529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M297.036,237.242c0,0-4.836-4.196-2.304-9.936C294.732,227.307,299.501,231.232,297.036,237.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M284.969,230.872c0,0,3.564-5.315,9.566-3.524C294.535,227.348,291.246,232.567,284.969,230.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M303.364,223.977c0,0-4.994-4.002-2.707-9.836C300.657,214.141,305.582,217.873,303.364,223.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M291.055,218.101c0,0,3.34-5.456,9.417-3.906C300.472,214.194,297.393,219.54,291.055,218.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M308.537,209.798c0,0-5.329-3.557-3.557-9.566C304.98,200.231,310.208,203.516,308.537,209.798"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M295.759,205.017c0,0,2.861-5.726,9.039-4.715C304.798,200.302,302.194,205.902,295.759,205.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M197.006,303.163c0,0,4.135-4.887,9.9-2.435C206.906,300.729,203.051,305.539,197.006,303.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M138.092,300.956 c-47.209-13.552-84.496-50.656-98.242-97.837c0,0-2.326-7.982-3.536-18.411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M121.359,302.635c0,0,1.305-6.271-4.172-9.309C117.187,293.326,115.76,299.331,121.359,302.635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M127.111,290.269c0,0-6.054-2.088-9.751,2.974C117.36,293.242,123.146,295.41,127.111,290.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M134.678,307.177c0,0,0.573-6.376-5.224-8.763C129.454,298.414,128.739,304.547,134.678,307.177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M138.956,294.223c0,0-6.25-1.364-9.338,4.09C129.617,298.313,135.615,299.791,138.956,294.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M109.029,296.963c0,0,1.968-6.101-3.16-9.696C105.869,287.267,103.817,293.081,109.029,296.963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M116.066,285.275c0,0-5.8-2.715-10.014,1.921C106.052,287.196,111.57,289.958,116.066,285.275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M97.348,289.958c0,0,2.208-6.008-2.768-9.804C94.58,280.154,92.294,285.883,97.348,289.958"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M104.847,278.572c0,0-5.687-2.945-10.084,1.518C94.763,280.09,100.168,283.073,104.847,278.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M85.44,281.504c0,0,2.86-5.722-1.665-10.053C83.775,271.451,80.867,276.896,85.44,281.504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M94.151,271.017c0,0-5.322-3.552-10.189,0.394C83.962,271.41,89.007,274.973,94.151,271.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M74.487,272.414c0,0,3.45-5.395-0.595-10.179C73.893,262.235,70.429,267.349,74.487,272.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M84.262,262.903c0,0-4.92-4.1-10.171-0.681C74.09,262.223,78.725,266.297,84.262,262.903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M64.732,261.93c0,0,3.664-5.249-0.18-10.189C64.552,251.74,60.881,256.699,64.732,261.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M74.885,252.822c0,0-4.749-4.286-10.136-1.094C64.749,251.729,69.21,255.994,74.885,252.822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M55.142,250.133c0,0,4.359-4.688,1.243-10.118C56.385,240.015,52.059,244.422,55.142,250.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M66.464,242.529c0,0-4.106-4.91-9.89-2.496C56.574,240.033,60.408,244.868,66.464,242.529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M46.86,237.242c0,0,4.831-4.196,2.307-9.936C49.167,227.307,44.396,231.232,46.86,237.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M58.921,230.872c0,0-3.562-5.315-9.566-3.524C49.355,227.348,52.652,232.567,58.921,230.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M40.534,223.977c0,0,4.996-4.002,2.7-9.836C43.233,214.141,38.314,217.873,40.534,223.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M52.842,218.101c0,0-3.345-5.456-9.416-3.906C43.427,214.194,46.504,219.54,52.842,218.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M35.355,209.798c0,0,5.33-3.557,3.558-9.566C38.914,200.231,33.682,203.516,35.355,209.798"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M48.132,205.017c0,0-2.854-5.726-9.039-4.715C39.094,200.302,41.698,205.902,48.132,205.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C1325",
    d: "M146.886,303.163c0,0-4.138-4.887-9.9-2.435C136.986,300.729,140.848,305.539,146.886,303.163"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#DCD2B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 166.471,
    y1: 79.518,
    x2: 162.933,
    y2: 83.598
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#DCD2B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 180.353,
    y1: 79.523,
    x2: 183.891,
    y2: 83.908
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#DCD2B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 180.353,
    y1: 258.113,
    x2: 184.148,
    y2: 253.704
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#DCD2B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 163.654,
    y1: 258.113,
    x2: 159.802,
    y2: 253.806
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8024 0.5968 -0.5968 0.8024 104.9043 255.8066)",
    fill: "#DCD2B1",
    fontFamily: "'BuiltTitlingRg-Regular'",
    fontSize: 12.4052
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7671 -0.6415 0.6415 0.7671 242.6074 253.0146)",
    fill: "#DCD2B1",
    fontFamily: "'BuiltTitlingRg-Regular'",
    fontSize: 12.4055
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "171.342,229.736 173.326,233.763 177.769,234.407 174.555,237.543 175.313,241.973  171.342,239.874 167.365,241.973 168.124,237.543 164.91,234.407 169.352,233.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "195.944,226.258 198.424,230 202.904,230.077 200.11,233.597 201.428,237.889 197.212,236.313  193.533,238.885 193.74,234.402 190.154,231.703 194.48,230.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "68.544,196.344 71.024,200.097 75.509,200.174 72.718,203.682 74.028,207.985 69.823,206.409  66.143,208.981 66.34,204.495 62.754,201.788 67.085,200.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "270.894,199.447 273.361,203.195 277.854,203.272 275.06,206.792 276.365,211.084 272.161,209.508  268.481,212.08 268.682,207.593 265.104,204.898 269.43,203.689  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "146.558,226.258 144.078,230 139.59,230.077 142.386,233.597 141.073,237.889 145.282,236.313  148.963,238.885 148.763,234.402 152.346,231.703 148.022,230.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "173.203,97.543 175.074,101.331 179.252,101.937 176.227,104.881 176.946,109.043 173.203,107.075  169.466,109.043 170.182,104.881 167.16,101.937 171.338,101.331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "196.336,113.735 198.663,110.215 202.885,110.135 200.261,106.833 201.491,102.795  197.541,104.276 194.081,101.856 194.265,106.069 190.893,108.621 194.968,109.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C1325",
    points: "149.901,113.735 147.573,110.215 143.352,110.135 145.975,106.833 144.744,102.795  148.698,104.276 152.16,101.856 151.978,106.069 155.343,108.621 151.274,109.743  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 172.041,
    y1: 8.658,
    x2: 172.041,
    y2: 19.388
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 166.402,
    y1: 8.761,
    x2: 166.781,
    y2: 19.478
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 160.775,
    y1: 9.051,
    x2: 161.523,
    y2: 19.752
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 155.154,
    y1: 9.546,
    x2: 156.276,
    y2: 20.213
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 149.561,
    y1: 10.231,
    x2: 151.052,
    y2: 20.85
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 143.993,
    y1: 11.111,
    x2: 145.856,
    y2: 21.678
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 138.456,
    y1: 12.189,
    x2: 140.686,
    y2: 22.683
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 132.963,
    y1: 13.455,
    x2: 135.559,
    y2: 23.863
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 127.519,
    y1: 14.917,
    x2: 130.476,
    y2: 25.227
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 122.127,
    y1: 16.562,
    x2: 125.44,
    y2: 26.765
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 116.798,
    y1: 18.398,
    x2: 120.466,
    y2: 28.475
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 111.532,
    y1: 20.419,
    x2: 115.549,
    y2: 30.365
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 106.339,
    y1: 22.626,
    x2: 110.704,
    y2: 32.425
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 101.23,
    y1: 25.005,
    x2: 105.937,
    y2: 34.648
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 96.206,
    y1: 27.567,
    x2: 101.244,
    y2: 37.038
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 91.276,
    y1: 30.3,
    x2: 96.641,
    y2: 39.586
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 86.445,
    y1: 33.203,
    x2: 92.129,
    y2: 42.296
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 81.717,
    y1: 36.271,
    x2: 87.711,
    y2: 45.166
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 77.097,
    y1: 39.504,
    x2: 83.402,
    y2: 48.181
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 72.596,
    y1: 42.896,
    x2: 79.196,
    y2: 51.352
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 68.209,
    y1: 46.449,
    x2: 75.107,
    y2: 54.663
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 63.958,
    y1: 50.146,
    x2: 71.135,
    y2: 58.117
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 59.833,
    y1: 53.991,
    x2: 67.283,
    y2: 61.705
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 55.848,
    y1: 57.976,
    x2: 63.563,
    y2: 65.431
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 52.002,
    y1: 62.099,
    x2: 59.967,
    y2: 69.275
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 48.302,
    y1: 66.355,
    x2: 56.516,
    y2: 73.248
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 44.754,
    y1: 70.735,
    x2: 53.204,
    y2: 77.345
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 41.36,
    y1: 75.236,
    x2: 50.037,
    y2: 81.544
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 38.127,
    y1: 79.855,
    x2: 47.019,
    y2: 85.858
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 35.055,
    y1: 84.583,
    x2: 44.153,
    y2: 90.269
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 32.149,
    y1: 89.422,
    x2: 41.438,
    y2: 94.779
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 29.416,
    y1: 94.349,
    x2: 38.887,
    y2: 99.389
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 26.855,
    y1: 99.375,
    x2: 36.498,
    y2: 104.074
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 24.474,
    y1: 104.484,
    x2: 34.271,
    y2: 108.847
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 22.271,
    y1: 109.674,
    x2: 32.215,
    y2: 113.694
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 20.25,
    y1: 114.937,
    x2: 30.329,
    y2: 118.605
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 18.415,
    y1: 120.265,
    x2: 28.616,
    y2: 123.583
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 16.769,
    y1: 125.662,
    x2: 27.072,
    y2: 128.613
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 15.308,
    y1: 131.107,
    x2: 25.715,
    y2: 133.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 14.04,
    y1: 136.597,
    x2: 24.528,
    y2: 138.827
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 12.962,
    y1: 142.136,
    x2: 23.522,
    y2: 143.995
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 12.081,
    y1: 147.705,
    x2: 22.699,
    y2: 149.196
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 11.392,
    y1: 153.299,
    x2: 22.06,
    y2: 154.421
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 10.9,
    y1: 158.914,
    x2: 21.601,
    y2: 159.666
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 10.604,
    y1: 164.546,
    x2: 21.328,
    y2: 164.917
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 10.506,
    y1: 170.179,
    x2: 21.23,
    y2: 170.179
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 10.603,
    y1: 175.823,
    x2: 21.326,
    y2: 175.444
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 10.899,
    y1: 181.447,
    x2: 21.6,
    y2: 180.703
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 11.39,
    y1: 187.07,
    x2: 22.06,
    y2: 185.945
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 12.078,
    y1: 192.658,
    x2: 22.699,
    y2: 191.172
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 12.959,
    y1: 198.228,
    x2: 23.52,
    y2: 196.367
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 14.036,
    y1: 203.77,
    x2: 24.524,
    y2: 201.539
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 15.303,
    y1: 209.257,
    x2: 25.71,
    y2: 206.668
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 16.764,
    y1: 214.701,
    x2: 27.07,
    y2: 211.75
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 18.41,
    y1: 220.097,
    x2: 28.611,
    y2: 216.785
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 20.246,
    y1: 225.428,
    x2: 30.325,
    y2: 221.759
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 22.268,
    y1: 230.692,
    x2: 32.208,
    y2: 226.677
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 24.468,
    y1: 235.88,
    x2: 34.266,
    y2: 231.514
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 26.849,
    y1: 240.988,
    x2: 36.49,
    y2: 236.295
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 29.408,
    y1: 246.013,
    x2: 38.88,
    y2: 240.976
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 32.142,
    y1: 250.948,
    x2: 41.431,
    y2: 245.585
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 35.046,
    y1: 255.778,
    x2: 44.145,
    y2: 250.098
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 38.119,
    y1: 260.51,
    x2: 47.009,
    y2: 254.515
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 41.352,
    y1: 265.13,
    x2: 50.028,
    y2: 258.821
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 44.745,
    y1: 269.628,
    x2: 53.194,
    y2: 263.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 48.292,
    y1: 274.016,
    x2: 56.511,
    y2: 267.121
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 51.992,
    y1: 278.267,
    x2: 59.966,
    y2: 271.091
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 55.837,
    y1: 282.387,
    x2: 63.551,
    y2: 274.937
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 59.823,
    y1: 286.381,
    x2: 67.272,
    y2: 278.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 63.947,
    y1: 290.224,
    x2: 71.123,
    y2: 282.257
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 68.204,
    y1: 293.923,
    x2: 75.097,
    y2: 285.712
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 72.583,
    y1: 297.471,
    x2: 79.186,
    y2: 289.021
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 77.085,
    y1: 300.863,
    x2: 83.39,
    y2: 292.182
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 81.703,
    y1: 304.095,
    x2: 87.699,
    y2: 295.202
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 86.432,
    y1: 307.171,
    x2: 92.116,
    y2: 298.077
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 91.263,
    y1: 310.075,
    x2: 96.628,
    y2: 300.781
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 96.198,
    y1: 312.804,
    x2: 101.229,
    y2: 303.334
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 101.217,
    y1: 315.365,
    x2: 105.923,
    y2: 305.729
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 106.332,
    y1: 317.751,
    x2: 110.69,
    y2: 307.952
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 111.516,
    y1: 319.953,
    x2: 115.534,
    y2: 310.004
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 116.783,
    y1: 321.975,
    x2: 120.451,
    y2: 311.891
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 122.112,
    y1: 323.805,
    x2: 125.428,
    y2: 313.608
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 127.503,
    y1: 325.463,
    x2: 130.461,
    y2: 315.146
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 132.949,
    y1: 326.914,
    x2: 135.548,
    y2: 316.512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 138.447,
    y1: 328.185,
    x2: 140.677,
    y2: 317.69
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 143.977,
    y1: 329.257,
    x2: 145.843,
    y2: 318.695
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 149.546,
    y1: 330.146,
    x2: 151.037,
    y2: 319.525
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 155.146,
    y1: 330.829,
    x2: 156.266,
    y2: 320.163
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 160.762,
    y1: 331.324,
    x2: 161.507,
    y2: 320.623
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 166.394,
    y1: 331.615,
    x2: 166.766,
    y2: 320.902
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 172.026,
    y1: 331.713,
    x2: 172.026,
    y2: 320.995
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 177.665,
    y1: 331.617,
    x2: 177.287,
    y2: 320.902
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 183.291,
    y1: 331.325,
    x2: 182.545,
    y2: 320.625
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 188.911,
    y1: 330.829,
    x2: 187.79,
    y2: 320.165
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 194.511,
    y1: 330.146,
    x2: 193.014,
    y2: 319.525
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 200.079,
    y1: 329.259,
    x2: 198.209,
    y2: 318.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 205.611,
    y1: 328.188,
    x2: 203.382,
    y2: 317.695
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 211.108,
    y1: 326.918,
    x2: 208.511,
    y2: 316.516
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 216.554,
    y1: 325.467,
    x2: 213.592,
    y2: 315.149
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 221.938,
    y1: 323.81,
    x2: 218.627,
    y2: 313.613
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 227.271,
    y1: 321.979,
    x2: 223.602,
    y2: 311.895
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 232.536,
    y1: 319.958,
    x2: 228.52,
    y2: 310.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 237.73,
    y1: 317.758,
    x2: 233.369,
    y2: 307.959
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 242.843,
    y1: 315.372,
    x2: 238.136,
    y2: 305.735
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 247.861,
    y1: 312.811,
    x2: 242.829,
    y2: 303.34
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 252.789,
    y1: 310.082,
    x2: 247.425,
    y2: 300.788
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 257.629,
    y1: 307.178,
    x2: 251.945,
    y2: 298.083
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 262.352,
    y1: 304.101,
    x2: 256.354,
    y2: 295.213
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 266.975,
    y1: 300.868,
    x2: 260.666,
    y2: 292.19
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 271.472,
    y1: 297.479,
    x2: 264.874,
    y2: 289.031
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 275.859,
    y1: 293.933,
    x2: 268.965,
    y2: 285.721
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 280.115,
    y1: 290.232,
    x2: 272.934,
    y2: 282.267
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 284.24,
    y1: 286.391,
    x2: 276.788,
    y2: 278.673
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 288.226,
    y1: 282.396,
    x2: 280.505,
    y2: 274.946
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 292.063,
    y1: 278.273,
    x2: 284.1,
    y2: 271.104
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 295.767,
    y1: 274.026,
    x2: 287.551,
    y2: 267.133
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 299.314,
    y1: 269.643,
    x2: 290.861,
    y2: 263.035
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 302.711,
    y1: 265.133,
    x2: 294.034,
    y2: 258.835
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 305.946,
    y1: 260.521,
    x2: 297.054,
    y2: 254.525
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 309.014,
    y1: 255.787,
    x2: 299.921,
    y2: 250.104
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 311.917,
    y1: 250.962,
    x2: 302.633,
    y2: 245.597
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 314.656,
    y1: 246.027,
    x2: 305.186,
    y2: 240.988
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 317.216,
    y1: 241.003,
    x2: 307.57,
    y2: 236.299
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 319.594,
    y1: 235.895,
    x2: 309.796,
    y2: 231.53
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 321.794,
    y1: 230.71,
    x2: 311.857,
    y2: 226.689
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 323.817,
    y1: 225.441,
    x2: 313.744,
    y2: 221.773
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 325.657,
    y1: 220.113,
    x2: 315.451,
    y2: 216.802
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 327.305,
    y1: 214.715,
    x2: 316.998,
    y2: 211.764
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 328.766,
    y1: 209.271,
    x2: 318.353,
    y2: 206.682
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 330.027,
    y1: 203.784,
    x2: 319.546,
    y2: 201.554
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 331.112,
    y1: 198.241,
    x2: 320.552,
    y2: 196.383
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 331.993,
    y1: 192.674,
    x2: 321.366,
    y2: 191.188
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 332.681,
    y1: 187.085,
    x2: 322.006,
    y2: 185.964
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 333.166,
    y1: 181.464,
    x2: 322.467,
    y2: 180.719
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 333.469,
    y1: 175.837,
    x2: 322.746,
    y2: 175.459
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 333.567,
    y1: 170.192,
    x2: 322.837,
    y2: 170.192
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 333.469,
    y1: 164.561,
    x2: 322.746,
    y2: 164.934
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 333.168,
    y1: 158.928,
    x2: 322.469,
    y2: 159.675
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 332.683,
    y1: 153.312,
    x2: 322.008,
    y2: 154.435
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 331.995,
    y1: 147.714,
    x2: 321.368,
    y2: 149.209
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 331.114,
    y1: 142.144,
    x2: 320.554,
    y2: 144.01
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 330.031,
    y1: 136.614,
    x2: 319.55,
    y2: 138.844
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 328.77,
    y1: 131.117,
    x2: 318.356,
    y2: 133.713
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 327.309,
    y1: 125.671,
    x2: 316.998,
    y2: 128.628
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 325.663,
    y1: 120.279,
    x2: 315.457,
    y2: 123.597
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 323.823,
    y1: 114.95,
    x2: 313.75,
    y2: 118.618
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 321.8,
    y1: 109.687,
    x2: 311.863,
    y2: 113.702
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 319.6,
    y1: 104.498,
    x2: 309.802,
    y2: 108.854
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 317.221,
    y1: 99.389,
    x2: 307.578,
    y2: 104.088
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 314.656,
    y1: 94.363,
    x2: 305.192,
    y2: 99.394
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 311.925,
    y1: 89.43,
    x2: 302.633,
    y2: 94.792
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 309.021,
    y1: 84.596,
    x2: 299.929,
    y2: 90.283
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 305.956,
    y1: 79.869,
    x2: 297.063,
    y2: 85.865
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 302.721,
    y1: 75.251,
    x2: 294.044,
    y2: 81.555
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 299.321,
    y1: 70.747,
    x2: 290.873,
    y2: 77.352
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 295.776,
    y1: 66.366,
    x2: 287.563,
    y2: 73.261
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 292.075,
    y1: 62.11,
    x2: 284.109,
    y2: 69.287
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 288.235,
    y1: 57.987,
    x2: 280.516,
    y2: 65.437
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 284.25,
    y1: 54,
    x2: 276.801,
    y2: 61.714
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 280.127,
    y1: 50.155,
    x2: 272.945,
    y2: 58.126
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 275.87,
    y1: 46.453,
    x2: 268.977,
    y2: 54.675
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 271.483,
    y1: 42.905,
    x2: 264.888,
    y2: 51.357
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 266.988,
    y1: 39.513,
    x2: 260.676,
    y2: 48.192
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 262.363,
    y1: 36.278,
    x2: 256.365,
    y2: 45.173
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 257.641,
    y1: 33.208,
    x2: 251.957,
    y2: 42.303
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 252.805,
    y1: 30.308,
    x2: 247.438,
    y2: 39.595
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 247.87,
    y1: 27.574,
    x2: 242.843,
    y2: 37.044
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 242.852,
    y1: 25.013,
    x2: 238.151,
    y2: 34.652
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 237.735,
    y1: 22.629,
    x2: 233.383,
    y2: 32.426
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 232.55,
    y1: 20.425,
    x2: 228.53,
    y2: 30.368
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 227.284,
    y1: 18.403,
    x2: 223.615,
    y2: 28.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 221.954,
    y1: 16.568,
    x2: 218.643,
    y2: 26.77
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 216.569,
    y1: 14.92,
    x2: 213.605,
    y2: 25.232
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 211.123,
    y1: 13.46,
    x2: 208.526,
    y2: 23.868
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 205.627,
    y1: 12.191,
    x2: 203.397,
    y2: 22.684
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 200.095,
    y1: 11.114,
    x2: 198.224,
    y2: 21.681
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 194.526,
    y1: 10.231,
    x2: 193.029,
    y2: 20.853
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 188.927,
    y1: 9.547,
    x2: 187.806,
    y2: 20.213
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 183.307,
    y1: 9.053,
    x2: 182.561,
    y2: 19.752
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#0C1325",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 177.68,
    y1: 8.761,
    x2: 177.303,
    y2: 19.479
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4d88400681d49e8dc3db71feb79890c1.svg";
export { ForwardRef as ReactComponent };